import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteRegulatoryDocumentMutationVariables = Types.Exact<{
  input: Types.DeleteRegulatoryDocumentInput;
}>;


export type DeleteRegulatoryDocumentMutation = { __typename?: 'Mutation', deleteRegulatoryDocument: { __typename?: 'DeleteRegulatoryDocumentPayload', regulatoryDocument?: { __typename?: 'RegulatoryDocument', id: string } | null } };


export const DeleteRegulatoryDocumentDocument = gql`
    mutation DeleteRegulatoryDocument($input: DeleteRegulatoryDocumentInput!) {
  deleteRegulatoryDocument(input: $input) {
    regulatoryDocument {
      id
    }
  }
}
    `;
export type DeleteRegulatoryDocumentMutationFn = Apollo.MutationFunction<DeleteRegulatoryDocumentMutation, DeleteRegulatoryDocumentMutationVariables>;

/**
 * __useDeleteRegulatoryDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteRegulatoryDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRegulatoryDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRegulatoryDocumentMutation, { data, loading, error }] = useDeleteRegulatoryDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteRegulatoryDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRegulatoryDocumentMutation, DeleteRegulatoryDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRegulatoryDocumentMutation, DeleteRegulatoryDocumentMutationVariables>(DeleteRegulatoryDocumentDocument, options);
      }
export type DeleteRegulatoryDocumentMutationHookResult = ReturnType<typeof useDeleteRegulatoryDocumentMutation>;
export type DeleteRegulatoryDocumentMutationResult = Apollo.MutationResult<DeleteRegulatoryDocumentMutation>;
export type DeleteRegulatoryDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteRegulatoryDocumentMutation, DeleteRegulatoryDocumentMutationVariables>;